import React, { useState, useEffect, useRef } from "react";
import styled from 'styled-components';
import PhoneInput from '../PhoneInput';
import { toE164, fromE164, localDigitsFromE164, formatPhoneDisplay } from '../../utils/phone';
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { registerPedidoMesa, getCategorias, getItens, getVinculoEmpresa, getAdicionaisCardapio, getCliente, getClienteByName, addClientToMesa } from "../../services/api";
import { getStoredUser } from '../../utils/safeStorage';
import { saveToLocalStorage, getFromLocalStorage } from '../../utils/localStorage';
import ModalAdicionais from "../../pages/Pdv/ModalAdicionais";
import { MdFastfood, MdShoppingCartCheckout, MdPerson, MdPersonAdd } from "react-icons/md";
import SafeImage from "../SafeImage";
import { HiChevronDoubleRight } from 'react-icons/hi';
import { filterByAvailability } from '../../utils/filterByAvailability';
import { formatPrice, formatPriceWithSymbol, getCurrencySymbol } from '../../utils/currency';
import ModalAddObsPedido from "../../pages/Pdv/ModalAddObsPedido";
import ModalAddObsItem from "../../pages/Pdv/ModalAddObsItem";
import Loading from "react-loading";

// ======================== STYLED COMPONENTS (padrão ModalPdv) ========================

const ModernLayout = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    overflow: hidden;

    @media (max-width: 900px) {
        flex-direction: column;
        overflow-y: auto;
    }
`;

const MenuSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    background: white;
    border-right: 1px solid #e5e7eb;
    overflow: hidden;

    @media (max-width: 900px) {
        border-right: none;
        border-bottom: 1px solid #e5e7eb;
        min-height: 50vh;
        overflow: visible;
    }
`;

const MenuHeader = styled.div`
    padding: 20px 24px 20px 60px;
    background: white;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        padding: 16px 16px 16px 56px;
    }
`;

const HeaderTitle = styled.div`
    h2 {
        margin: 0;
        font-size: 22px;
        font-weight: 700;
        color: #1e293b;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    p {
        margin: 4px 0 0;
        font-size: 13px;
        color: #64748b;
    }

    @media (max-width: 600px) {
        h2 {
            font-size: 17px;
            gap: 8px;
        }
    }
`;

const SendToCartBtn = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #318CD5 0%, #4facfe 100%);
    color: white;
    border: none;
    border-radius: 10px;
    padding: 12px 20px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(49, 140, 213, 0.25);
    white-space: nowrap;
    flex-shrink: 0;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(49, 140, 213, 0.35);
    }

    svg {
        font-size: 18px;
    }

    @media (max-width: 600px) {
        padding: 10px 16px;
        font-size: 13px;
        width: 100%;
        justify-content: center;
    }
`;

const MenuContent = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;

    @media (max-width: 700px) {
        flex-direction: column;
    }
`;

const CategoriesSidebar = styled.div`
    width: 180px;
    background: #f8fafc;
    border-right: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    h3 {
        margin: 0;
        padding: 16px;
        font-size: 14px;
        font-weight: 600;
        color: #475569;
        border-bottom: 1px solid #e5e7eb;
    }

    @media (max-width: 700px) {
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #e5e7eb;
        max-height: 140px;

        h3 {
            padding: 10px 16px;
            font-size: 13px;
        }
    }
`;

const CategoriesList = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    @media (max-width: 700px) {
        flex-direction: row;
        overflow-x: auto;
        overflow-y: hidden;
        flex-wrap: nowrap;
        padding: 8px 12px;
        gap: 6px;
        -webkit-overflow-scrolling: touch;
    }
`;

const CategoryBtn = styled.button`
    display: flex;
    align-items: center;
    background: ${({ active }) => active ? 'linear-gradient(135deg, #318CD5 0%, #4facfe 100%)' : 'white'};
    color: ${({ active }) => active ? 'white' : '#475569'};
    border: 1px solid ${({ active }) => active ? 'transparent' : '#e5e7eb'};
    padding: 10px 14px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;
    width: 100%;
    font-size: 13px;
    font-weight: 600;
    box-shadow: ${({ active }) => active ? '0 2px 8px rgba(49, 140, 213, 0.25)' : '0 1px 2px rgba(0, 0, 0, 0.05)'};

    &:hover {
        background: ${({ active }) => active ? 'linear-gradient(135deg, #2678b8 0%, #3d9ae6 100%)' : '#f1f5f9'};
        transform: translateX(2px);
    }

    @media (max-width: 700px) {
        white-space: nowrap;
        flex-shrink: 0;
        width: auto;
        padding: 8px 14px;
        font-size: 12px;

        &:hover {
            transform: none;
        }
    }
`;

const ItemsContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 20px;

    @media (max-width: 600px) {
        padding: 12px;
    }
`;

const CategorySectionStyled = styled.div`
    margin-bottom: 28px;
`;

const CategoryHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;

    h4 {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #1e293b;
    }

    &::after {
        content: '';
        flex: 1;
        height: 2px;
        background: linear-gradient(to right, #318CD5, transparent);
    }
`;

const ItemsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;

    @media (max-width: 600px) {
        grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
        gap: 10px;
    }
`;

const ItemCard = styled.div`
    background: white;
    border: 2px solid ${({ selected }) => selected ? '#318CD5' : '#e5e7eb'};
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: ${({ selected }) => selected ? '0 4px 12px rgba(49, 140, 213, 0.2)' : '0 1px 3px rgba(0, 0, 0, 0.05)'};

    &:hover {
        border-color: #318CD5;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(49, 140, 213, 0.15);
    }
`;

const ItemImage = styled.div`
    width: 100%;
    height: 100px;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    svg {
        font-size: 48px;
        color: #94a3b8;
    }
`;

const ItemInfo = styled.div`
    padding: 12px;

    h5 {
        margin: 0 0 6px;
        font-size: 13px;
        font-weight: 600;
        color: #1e293b;
        line-height: 1.3;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .price {
        font-size: 14px;
        font-weight: 700;
        color: #318CD5;
    }
`;

const ItemQuantity = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    margin-top: 8px;
    background: #f8fafc;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e5e7eb;

    button {
        width: 32px;
        height: 32px;
        border: none;
        background: transparent;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #475569;
        transition: all 0.15s ease;

        &:hover {
            background: #e2e8f0;
            color: #318CD5;
        }
    }

    input {
        width: 40px;
        height: 32px;
        border: none;
        border-left: 1px solid #e5e7eb;
        border-right: 1px solid #e5e7eb;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: #1e293b;
        background: white;
    }
`;

const CartSection = styled.div`
    width: 400px;
    min-width: 380px;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    background: white;
    overflow: hidden;

    @media (max-width: 1200px) {
        width: 360px;
        min-width: 340px;
    }

    @media (max-width: 900px) {
        width: 100%;
        min-width: unset;
        max-width: unset;
        min-height: 300px;
    }
`;

const CartHeader = styled.div`
    padding: 16px 20px;
    background: #f8fafc;
    border-bottom: 1px solid #e5e7eb;
    flex-shrink: 0;
`;

const CartTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        color: #1e293b;
    }
`;

const CartActions = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

const ActionBtn = styled.button`
    padding: 8px 14px;
    border-radius: 8px;
    border: 1.5px solid ${({ variant }) =>
        variant === 'primary' ? '#318CD5' :
        variant === 'danger' ? '#ef4444' : '#d1d5db'};
    background: ${({ variant, active }) =>
        active ? (variant === 'primary' ? '#318CD5' : variant === 'danger' ? '#ef4444' : '#f1f5f9') :
        'white'};
    color: ${({ variant, active }) =>
        active ? 'white' :
        variant === 'primary' ? '#318CD5' :
        variant === 'danger' ? '#ef4444' : '#475569'};
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    text-transform: uppercase;
    letter-spacing: 0.025em;

    &:hover {
        background: ${({ variant }) =>
            variant === 'primary' ? '#318CD5' :
            variant === 'danger' ? '#ef4444' : '#f1f5f9'};
        color: ${({ variant }) =>
            variant === 'danger' || variant === 'primary' ? 'white' : '#1e293b'};
    }
`;

const CartItems = styled.div`
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
`;

const EmptyCart = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 40px 20px;
    text-align: center;
    color: #94a3b8;

    svg {
        font-size: 64px;
        margin-bottom: 16px;
        color: #cbd5e1;
    }

    h4 {
        margin: 0 0 8px;
        font-size: 16px;
        font-weight: 600;
        color: #64748b;
    }

    p {
        margin: 0;
        font-size: 13px;
        color: #94a3b8;
    }
`;

const CartFooter = styled.div`
    flex-shrink: 0;
    border-top: 1px solid #e5e7eb;
    background: white;
`;

const CartSummary = styled.div`
    padding: 16px 20px;
    background: #f8fafc;
`;

const SummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;

    span {
        font-size: 13px;
        color: #64748b;
    }

    strong {
        font-size: 13px;
        color: #1e293b;
    }

    &.total {
        margin-top: 12px;
        padding-top: 12px;
        border-top: 2px solid #e5e7eb;

        span {
            font-size: 15px;
            font-weight: 700;
            color: #1e293b;
        }

        strong {
            font-size: 18px;
            font-weight: 800;
            color: #318CD5;
        }
    }
`;

const CustomerSection = styled.div`
    padding: 16px 20px;
    border-top: 1px solid #e5e7eb;
    position: relative;
`;

const CustomerInputs = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;

    input {
        flex: 1;
        min-width: 120px;
        padding: 10px 14px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #1e293b;
        transition: all 0.2s ease;

        &:focus {
            outline: none;
            border-color: #318CD5;
            box-shadow: 0 0 0 3px rgba(49, 140, 213, 0.1);
        }

        &::placeholder {
            color: #94a3b8;
        }
    }

    @media (max-width: 400px) {
        flex-direction: column;

        input {
            width: 100%;
        }
    }
`;

const MesaClientesList = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 10px;
`;

const MesaClienteChip = styled.button`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1.5px solid ${({ active }) => active ? '#318CD5' : '#e5e7eb'};
    background: ${({ active }) => active ? 'rgba(49, 140, 213, 0.08)' : '#fff'};
    color: ${({ active }) => active ? '#318CD5' : '#475569'};

    &:hover {
        border-color: #318CD5;
        background: rgba(49, 140, 213, 0.05);
        color: #318CD5;
    }

    svg {
        font-size: 14px;
    }
`;

const MesaClienteAddBtn = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1.5px dashed #cbd5e1;
    background: transparent;
    color: #94a3b8;

    &:hover {
        border-color: #318CD5;
        color: #318CD5;
    }

    svg {
        font-size: 14px;
    }
`;

const CustomersDropdown = styled.div`
    position: absolute;
    top: calc(100% - 10px);
    left: 20px;
    right: 20px;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
`;

const CustomerOption = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid #f1f5f9;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #f8fafc;
    }

    .customer-phone {
        font-size: 14px;
        color: #64748b;
        font-weight: 500;
    }

    .customer-name {
        font-size: 14px;
        color: #1e293b;
        font-weight: 600;
    }
`;

const SubmitBtn = styled.button`
    width: calc(100% - 40px);
    margin: 12px 20px 20px;
    padding: 14px 24px;
    background: ${({ disabled }) => disabled ? '#94a3b8' : 'linear-gradient(135deg, #318CD5 0%, #4facfe 100%)'};
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 700;
    cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s ease;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    box-shadow: ${({ disabled }) => disabled ? 'none' : '0 4px 12px rgba(49, 140, 213, 0.3)'};

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(49, 140, 213, 0.4);
    }
`;

const LoadingWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
`;

// Wrapper com borda decorativa azul à esquerda (mesmo padrão do ModalPdv)
// Usa margin negativa para compensar o padding do CustomDrawer (24px)
const ComponentWrapper = styled.div`
    position: relative;
    width: calc(100% + 48px);
    height: calc(100% + 48px);
    margin: -24px;
    background: #f8fafc;
    overflow: hidden;

    /* Borda decorativa à esquerda */
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: linear-gradient(180deg, #318CD5 0%, #4facfe 50%, #318CD5 100%);
        z-index: 10;
    }

    @media (max-width: 768px) {
        width: calc(100% + 32px);
        height: calc(100% + 32px);
        margin: -16px;
    }
`;

// Botão de colapsar com seta >> (posicionado na borda esquerda)
const CollapseButton = styled.button`
    position: absolute;
    top: 20px;
    left: 0px;
    width: 44px;
    height: 44px;
    background: linear-gradient(135deg, #318CD5 0%, #4facfe 100%);
    border: none;
    border-radius: 0 12px 12px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 22px;
    box-shadow: 4px 4px 16px rgba(49, 140, 213, 0.3);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 101;

    &:hover {
        background: linear-gradient(135deg, #2678b8 0%, #3d9ae6 100%);
        width: 52px;
        box-shadow: 6px 4px 20px rgba(49, 140, 213, 0.4);
    }

    &:active {
        transform: scale(0.95);
    }

    svg {
        transition: transform 0.2s ease;
    }

    &:hover svg {
        transform: translateX(3px);
    }
`;

// ======================== COMPONENT ========================

function PedidosComponent({ mesaId, mesaName, mesaClientes = [], onFinish, onClose }) {
    const { t } = useTranslation('mesas');
    const userParse = getStoredUser();
    const userID = userParse?._id;
    const empresaLocalStorage = localStorage.getItem("empresa");
    const empresaParse = JSON.parse(empresaLocalStorage);
    const nomeEmpresa = empresaParse.name;
    const nomeEmpresaForUrl = nomeEmpresa
        .replace(/\s+/g, "-")
        .replace(/[A-Z]/g, (c) => c.toLowerCase());

    const [empresa, setEmpresa] = useState(null);
    const [idEmpresa, setIdEmpresa] = useState(null);
    const [categorias, setCategorias] = useState([]);
    const [itens, setItens] = useState([]);
    const [selectedCategoria, setSelectedCategoria] = useState("");
    const [nomeCliente, setNomeCliente] = useState("");
    const [selectedCliente, setSelectedCliente] = useState(null);
    const [telefone, setTelefone] = useState('');
    const [clientes, setClientes] = useState([]);
    const [selectedMesaCliente, setSelectedMesaCliente] = useState(null);
    const [localMesaClientes, setLocalMesaClientes] = useState(mesaClientes || []);
    const [itensSelecionados, setItensSelecionados] = useState([]);
    const [itensCarrinho, setItensCarrinho] = useState(getFromLocalStorage('itensCarrinho') || []);
    const [editarPedido, setEditarPedido] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const containerRef = useRef(null);
    const [showAdicionaisModal, setShowAdicionaisModal] = useState(false);
    const [adicionaisCompletos, setAdicionaisCompletos] = useState([]);
    const [quantidades, setQuantidades] = useState({});
    const [showModalAddObsPedido, setShowModalAddObsPedido] = useState(true);
    const [itemSelecionadoParaObs, setItemSelecionadoParaObs] = useState(null);
    const [obsItem, setObsItem] = useState("");
    const [showModalAddObsItem, setShowModalAddObsItem] = useState(true);
    const [valueDescricao, setValueDescricao] = useState('');
    const [loading, setLoading] = useState(true);

    // ===== Sorting =====
    const categoriasSorted = categorias ? [...categorias].sort((a, b) => a.order - b.order) : [];
    const itensSorted = itens ? [...itens].sort((a, b) => a.order - b.order) : [];

    // ===== Data Fetching =====
    useEffect(() => {
        let isMounted = true;

        const fetchEmpresa = async () => {
            try {
                const response = await getVinculoEmpresa(userID);
                if (response.data.vinculo) {
                    const vinculo = response.data.vinculo;
                    if (isMounted) {
                        setEmpresa(vinculo);
                        setIdEmpresa(vinculo.id_empresa);
                        const categoriaTemp = await getCategorias();
                        const itemTemp = await getItens();
                        if (isMounted) {
                            setCategorias(filterByAvailability(categoriaTemp.data.categorias));
                            setItens(filterByAvailability(itemTemp.data.itens));
                            setLoading(false);
                        }
                    }
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao buscar dados:", error);
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchEmpresa();

        return () => {
            isMounted = false;
        };
    }, [userID]);

    useEffect(() => {
        saveToLocalStorage('itensCarrinho', itensCarrinho);
    }, [itensCarrinho]);

    // ===== Adicionais =====
    const fetchAdicionais = async (item) => {
        try {
            const response = await getAdicionaisCardapio(idEmpresa, nomeEmpresaForUrl);
            const adicionaisFromDB = response.data.adicionais;
            if (item.adicionais && adicionaisFromDB) {
                const adicionaisEncontrados = adicionaisFromDB.filter(adicionalDB =>
                    item.adicionais.some(adicionalItem => adicionalItem.value === adicionalDB._id)
                );
                // Tipo A: ordenar os grupos pela ordem definida no item (drag-and-drop)
                const __ordemGrupos = (item?.adicionais || []).map(a => String(a.value));
                adicionaisEncontrados.sort((a, b) => __ordemGrupos.indexOf(String(a._id)) - __ordemGrupos.indexOf(String(b._id)));
                if (adicionaisEncontrados.length > 0) {
                    setAdicionaisCompletos(adicionaisEncontrados);
                    setQuantidades({});
                    setShowAdicionaisModal(true);
                } else {
                    incrementCount(item);
                }
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao buscar adicionais:', error);
        }
    };

    const handleFinalizarAdicionais = (item, selectedAdicionais) => {
        const updatedItem = {
            ...item,
            adicionais: selectedAdicionais,
            quantity: 1
        };
        updateCartItem(updatedItem);
        setShowAdicionaisModal(false);
        setQuantidades({});
        setAdicionaisCompletos([]);
    };

    // ===== Item Selection =====
    const handleItemClick = (item) => {
        const itemExistente = itensSelecionados.find(i => i._id === item._id);
        if (itemExistente) {
            incrementCount(item);
        } else {
            setSelectedItem(item);
            if (item.has_adicional || item.type === "pizza") {
                fetchAdicionais(item);
            } else {
                incrementCount(item);
            }
        }
    };

    const updateCartItem = (updatedItem) => {
        setItensSelecionados(prevItens => {
            const index = prevItens.findIndex(item => item._id === updatedItem._id);
            if (index !== -1) {
                const newItensSelecionados = [...prevItens];
                newItensSelecionados[index] = updatedItem;
                return newItensSelecionados;
            }
            return [...prevItens, updatedItem];
        });
    };

    // ===== Send to Cart =====
    const handleEnviarParaCarrinho = () => {
        if (itensSelecionados.length === 0) {
            toast(t('newOrder.noItemsSelected'), { autoClose: 2000, type: "warning" });
            return;
        }

        const updatedCarrinho = [...itensCarrinho];

        itensSelecionados.forEach(selecionado => {
            const existingItemIndex = updatedCarrinho.findIndex(i =>
                i._id === selecionado._id &&
                JSON.stringify(i.adicionais) === JSON.stringify(selecionado.adicionais)
            );

            const adicionaisAtualizados = selecionado.adicionais.map(grupo => ({
                ...grupo,
                calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                calcular_media: grupo.calcular_media ?? false,
            }));

            const itemAtualizado = {
                ...selecionado,
                adicionais: adicionaisAtualizados,
            };

            if (existingItemIndex > -1) {
                updatedCarrinho[existingItemIndex].quantity += selecionado.quantity;
                updatedCarrinho[existingItemIndex].adicionais.forEach((grupo, groupIndex) => {
                    grupo.adicionais.forEach((adicional, adicionalIndex) => {
                        adicional.quantity += selecionado.adicionais[groupIndex].adicionais[adicionalIndex].quantity;
                    });
                });
            } else {
                updatedCarrinho.push(itemAtualizado);
            }
        });

        toast(t('newOrder.itemsSentToCart'), { autoClose: 1000, type: "success" });
        setItensCarrinho(updatedCarrinho);
        setItensSelecionados([]);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    // ===== Quantity Controls (Selection) =====
    const handleChange = (e, item) => {
        const newQuantity = parseInt(e.target.value, 10);
        if (isNaN(newQuantity) || newQuantity < 0) return;
        const index = itensSelecionados.findIndex(i => i._id === item._id);
        if (index !== -1) {
            const newItensSelecionados = [...itensSelecionados];
            newItensSelecionados[index].quantity = newQuantity;
            setItensSelecionados(newItensSelecionados);
        }
    };

    const incrementCount = (item) => {
        const index = itensSelecionados.findIndex(i => i._id === item._id);
        if (index !== -1) {
            const newItensSelecionados = [...itensSelecionados];
            newItensSelecionados[index].quantity += 1;
            setItensSelecionados(newItensSelecionados);
        } else {
            setItensSelecionados([...itensSelecionados, { ...item, quantity: 1 }]);
        }
    };

    const decrementCount = (item) => {
        const index = itensSelecionados.findIndex(i => i._id === item._id);
        if (index !== -1) {
            const newItensSelecionados = [...itensSelecionados];
            if (newItensSelecionados[index].quantity > 1) {
                newItensSelecionados[index].quantity -= 1;
            } else {
                newItensSelecionados.splice(index, 1);
            }
            setItensSelecionados(newItensSelecionados);
        }
    };

    // ===== Observations =====
    const handleAddObsPedido = () => {
        setShowModalAddObsPedido(!showModalAddObsPedido);
    };

    const handleAddObsItem = (item, cartIndex) => {
        setItemSelecionadoParaObs({ ...item, _cartIndex: cartIndex });
        setObsItem(item.obs_item || "");
        setShowModalAddObsItem(!showModalAddObsItem);
    };

    const handleSaveObsItem = () => {
        const updatedCarrinho = itensCarrinho.map((prod, idx) => {
            if (idx === itemSelecionadoParaObs._cartIndex) {
                return { ...prod, obs_item: obsItem };
            }
            return prod;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
        setShowModalAddObsItem(false);
        toast(t('newOrder.obsAdded'), { autoClose: 2000, type: "success" });
    };

    // ===== Cart Item Management =====
    const handleRemoveItem = (item, cartIndex) => {
        const updatedCarrinho = itensCarrinho.filter((_, idx) => idx !== cartIndex);
        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
        toast(t('newOrder.itemRemoved'), { autoClose: 1000, type: "success" });
    };

    const handleEditaPedido = () => {
        setEditarPedido(true);
    };

    const handleConcluirEdicao = () => {
        saveToLocalStorage('itensCarrinho', itensCarrinho);
        setEditarPedido(false);
    };

    const handleDeletePedido = () => {
        setItensCarrinho([]);
        setEditarPedido(false);
        setValueDescricao('');
        toast(t('newOrder.itemsDeleted'), { autoClose: 2500, type: "success" });
    };

    useEffect(() => {
        if (itensCarrinho.length === 0) {
            setEditarPedido(false);
        }
    }, [itensCarrinho]);

    // ===== Cart Quantity Controls =====
    const handleChangeLocalStorage = (e, cartIndex) => {
        const newQuantity = parseInt(e.target.value, 10);
        if (isNaN(newQuantity) || newQuantity < 0) return;

        const updatedCarrinho = itensCarrinho.map((i, idx) => {
            if (idx === cartIndex) {
                return { ...i, quantity: newQuantity };
            }
            return i;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    const incrementCountLocalStorage = (cartIndex) => {
        const updatedCarrinho = itensCarrinho.map((i, idx) => {
            if (idx === cartIndex) {
                return {
                    ...i,
                    quantity: i.quantity + 1,
                    adicionais: i.adicionais.map(grupo => ({
                        ...grupo,
                        calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                        calcular_media: grupo.calcular_media ?? false,
                        adicionais: grupo.adicionais.map(adicional => ({
                            ...adicional,
                            quantity: adicional.quantity
                        }))
                    }))
                };
            }
            return i;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    const decrementCountLocalStorage = (cartIndex) => {
        const updatedCarrinho = itensCarrinho.reduce((acc, i, idx) => {
            if (idx === cartIndex) {
                if (i.quantity > 1) {
                    acc.push({
                        ...i,
                        quantity: i.quantity - 1,
                        adicionais: i.adicionais.map(grupo => ({
                            ...grupo,
                            calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                            calcular_media: grupo.calcular_media ?? false,
                            adicionais: grupo.adicionais.map(adicional => ({
                                ...adicional,
                                quantity: adicional.quantity
                            }))
                        }))
                    });
                }
            } else {
                acc.push(i);
            }
            return acc;
        }, []);

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    // ===== Adicionais Count in Cart =====
    const incrementAdicionalCount = (cartIndex, grupoId, adicionalId) => {
        const updatedCarrinho = itensCarrinho.map((i, idx) => {
            if (idx === cartIndex) {
                return {
                    ...i,
                    adicionais: i.adicionais.map(grupo => {
                        if (grupo.grupoId === grupoId) {
                            return {
                                ...grupo,
                                calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                                calcular_media: grupo.calcular_media ?? false,
                                adicionais: grupo.adicionais.map(adicional => {
                                    if (adicional.adicionalId === adicionalId) {
                                        return { ...adicional, quantity: adicional.quantity + 1 };
                                    }
                                    return adicional;
                                })
                            };
                        }
                        return grupo;
                    })
                };
            }
            return i;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    const decrementAdicionalCount = (cartIndex, grupoId, adicionalId) => {
        const updatedCarrinho = itensCarrinho.map((i, idx) => {
            if (idx === cartIndex) {
                return {
                    ...i,
                    adicionais: i.adicionais.map(grupo => {
                        if (grupo.grupoId === grupoId) {
                            return {
                                ...grupo,
                                calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                                calcular_media: grupo.calcular_media ?? false,
                                adicionais: grupo.adicionais.map(adicional => {
                                    if (adicional.adicionalId === adicionalId && adicional.quantity > 1) {
                                        return { ...adicional, quantity: adicional.quantity - 1 };
                                    }
                                    return adicional;
                                })
                            };
                        }
                        return grupo;
                    })
                };
            }
            return i;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    // ===== Scroll to Category =====
    const handleScrollOnClick = (mongodbId) => {
        const element = document.getElementById(mongodbId);
        if (element) {
            setSelectedCategoria(mongodbId);
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    // ===== Customer Search =====
    const normalizePhoneNumber = (phone) => {
        return phone.replace(/[^\d]/g, '');
    };

    const fetchClientes = async (inputValue, searchType = 'phone') => {
        try {
            let response;
            if (searchType === 'phone') {
                response = await getCliente(idEmpresa, normalizePhoneNumber(inputValue));
            } else {
                response = await getClienteByName(idEmpresa, inputValue);
            }
            if (response.status === 200) {
                const clientesData = response.data.clientes.map(cliente => ({ ...cliente }));
                setClientes(clientesData);
                return clientesData;
            }
            setClientes([]);
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao buscar clientes:", error);
            setClientes([]);
            return [];
        }
    };

    const handleNomeChange = async (event) => {
        const inputValue = event.target.value;
        setNomeCliente(inputValue);

        const normalizedName = inputValue.trim();
        if (normalizedName.length >= 2) {
            await fetchClientes(inputValue, 'name');
        } else {
            setClientes([]);
        }

        if (!selectedCliente || selectedCliente.nome !== inputValue) {
            setSelectedCliente({ ...selectedCliente, nome: inputValue });
        }
    };

    const handleTelefoneChange = async (val) => {
        setTelefone(val || '');

        const digits = localDigitsFromE164(val);
        if (digits.length >= 3) {
            await fetchClientes(digits, 'phone');
        } else {
            setClientes([]);
        }
        setSelectedCliente(null);
        setNomeCliente("");
    };

    const handleClienteClick = (cliente) => {
        setSelectedCliente(cliente);
        setNomeCliente(cliente.nome);
        setTelefone(toE164(cliente.telefone_completo || cliente.telefone));
        setClientes([]);
    };

    // Selecionar cliente existente da mesa
    const handleSelectMesaCliente = (cliente) => {
        if (selectedMesaCliente?.nome === cliente.nome) {
            // Deselect
            setSelectedMesaCliente(null);
            setNomeCliente('');
            setTelefone('');
        } else {
            setSelectedMesaCliente(cliente);
            setNomeCliente(cliente.nome || '');
            setTelefone(toE164(cliente.celular) || '');
        }
        setClientes([]);
    };

    // Salvar novo cliente na mesa via API
    const handleSaveNewClientToMesa = async () => {
        const nome = nomeCliente.trim();
        if (!nome || nome === 'Nao informado') return;

        // Verificar se ja existe
        const jaExiste = localMesaClientes.some(c => c.nome === nome);
        if (jaExiste) return;

        try {
            await addClientToMesa({
                mesa_id: mesaId,
                nome,
                celular: telefone.replace(/\D/g, ''),
                quantidade_pessoas: 1,
            });
            setLocalMesaClientes(prev => [...prev, { nome, celular: telefone.replace(/\D/g, ''), quantidade_pessoas: 1 }]);
            setSelectedMesaCliente({ nome, celular: telefone.replace(/\D/g, '') });
        } catch (error) {
            console.error('Erro ao salvar cliente na mesa:', error);
        }
    };

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setClientes([]);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (telefone === "") {
            setSelectedCliente(null);
        }
    }, [telefone]);

    // ===== Price Calculation =====
    const subTotal = Array.isArray(itensCarrinho) ? itensCarrinho.reduce((sum, item) => {
        const adicionaisSum = Array.isArray(item.adicionais) ? item.adicionais.reduce((acc, grupo) => {
            if (grupo.calcular_maior_valor) {
                const maxAdicionalValue = Array.isArray(grupo.adicionais)
                    ? Object.values(
                        grupo.adicionais.reduce((acc, adicional) => {
                            if (!acc[adicional.adicionalId]) {
                                acc[adicional.adicionalId] = { ...adicional, total: adicional.price };
                            } else {
                                acc[adicional.adicionalId].total += Number(adicional.price);
                            }
                            return acc;
                        }, {})
                    ).reduce((max, adicional) => {
                        return adicional.total > max ? adicional.total : max;
                    }, 0)
                    : 0;
                return acc + maxAdicionalValue;
            } else if (grupo.calcular_media) {
                const adicionaisSelecionados = Array.isArray(grupo.adicionais)
                    ? grupo.adicionais.filter(adicional => adicional.quantity > 0)
                    : [];
                if (adicionaisSelecionados.length > 0) {
                    const somaValores = adicionaisSelecionados.reduce((subAcc, adicional) => {
                        return subAcc + (adicional.price * adicional.quantity);
                    }, 0);
                    const mediaValor = somaValores / adicionaisSelecionados.length;
                    return acc + mediaValor;
                }
                return acc;
            } else {
                const totalAdicionais = Array.isArray(grupo.adicionais)
                    ? grupo.adicionais.reduce((subAcc, adicional) => {
                        return subAcc + (adicional.price * adicional.quantity);
                    }, 0)
                    : 0;
                return acc + totalAdicionais;
            }
        }, 0) : 0;

        // Adicionais sempre por unidade, multiplicam pela quantidade (modelo iFood)
        const price = item.price_salao || item.price;
        return sum + (price + adicionaisSum) * item.quantity;
    }, 0) : 0;

    const valorTotal = isNaN(Number(subTotal)) ? 0 : Number(subTotal);

    // ===== Render Adicionais in Cart =====
    const renderAdicionais = (cartIndex, adicionais) => {
        if (!adicionais || !Array.isArray(adicionais)) return null;
        // Buscar quantidade do item no carrinho para multiplicar adicionais (modelo iFood)
        const cartItem = itensCarrinho[cartIndex];
        const itemQty = cartItem?.quantity || 1;
        return adicionais.map(grupo => (
            <div key={grupo.grupoId} style={{ marginTop: '6px', paddingLeft: '8px', borderLeft: '2px solid #e5e7eb' }}>
                <span style={{ fontWeight: 'bold', fontSize: '11px', color: '#475569' }}>{grupo.grupoTitle}</span>
                {Array.isArray(grupo.adicionais) && grupo.adicionais.map(adicional => (
                    <div key={adicional.adicionalId} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '11px', color: '#64748b', padding: '2px 0' }}>
                        <span style={{ flex: 1 }}>{adicional.title} ({grupo.calcular_maior_valor || grupo.calcular_media
                            ? (adicional.quantity * itemQty) > grupo.adicionais.length
                                ? `${grupo.adicionais.length}/${grupo.adicionais.length}`
                                : `${adicional.quantity * itemQty}/${grupo.adicionais.length}`
                            : `x${adicional.quantity * itemQty}`})</span>
                        <span style={{ minWidth: 50, textAlign: 'right' }}>
                            {formatPriceWithSymbol(
                                grupo.calcular_media
                                    ? (grupo.adicionais.reduce((acc, subAdicional) => acc + (subAdicional.price * subAdicional.quantity), 0) /
                                        grupo.adicionais.reduce((acc, subAdicional) => acc + subAdicional.quantity, 0) / grupo.adicionais.length) * itemQty
                                    : grupo.calcular_maior_valor
                                        ? adicional.price === Math.max(...grupo.adicionais.map(subAdicional => subAdicional.price))
                                            ? Math.max(...grupo.adicionais.map(subAdicional => subAdicional.price)) * itemQty
                                            : 0
                                        : (adicional.price * adicional.quantity * itemQty)
                            )}
                        </span>
                    </div>
                ))}
            </div>
        ));
    };

    // ===== Submit Order =====
    const handleSubmitAPI = () => {
        const itensPayload = itensCarrinho.map(item => {
            const { title, price, price_salao, quantity, adicionais, obs_item } = item;
            const valor = price_salao || price || 0;
            return { nomeItem: title, valor, quantidade: quantity, grupo_adicionais: adicionais, obs_item };
        });

        if (itensPayload.length === 0) {
            toast(t('newOrder.noItemsWarning'), { autoClose: 3000, type: "warning" });
            return;
        }

        const celular_cliente = fromE164(telefone);
        const nome_cliente = nomeCliente;

        // Salvar cliente na mesa se for novo
        const nomeNormalizado = (nome_cliente || '').trim();
        if (nomeNormalizado && nomeNormalizado !== 'Nao informado') {
            const jaExiste = localMesaClientes.some(c => c.nome === nomeNormalizado);
            if (!jaExiste) {
                addClientToMesa({
                    mesa_id: mesaId,
                    nome: nomeNormalizado,
                    celular: (celular_cliente || '').replace(/\D/g, ''),
                    quantidade_pessoas: 1,
                }).catch(err => console.error('Erro ao salvar cliente na mesa:', err));
            }
        }

        registerPedidoMesa({
            mesa_id: mesaId,
            itens: itensPayload,
            celular_cliente,
            nome_cliente,
            valor_total: valorTotal,
            observacoes: valueDescricao,
            quantidade_pessoas: 1,
        }).then(cast => {
            if (cast.status === 201) {
                localStorage.removeItem('itensCarrinho');
                setValueDescricao('');
                setItensCarrinho([]);
                setSelectedCliente(null);
                setTelefone('');
                setClientes([]);
                setNomeCliente('');

                toast(cast?.data?.msg || t('newOrder.orderSuccess'), { autoClose: 5000, type: "success" });
                onFinish && onFinish();
            } else {
                toast(cast?.data?.msg || t('newOrder.orderError'), { autoClose: 5000, type: "error" });
            }
        }).catch(err => {
            const msg = err?.response?.data?.msg || t('newOrder.orderError');
            toast(msg, { autoClose: 5000, type: "error" });
        });
    };

    // ======================== RENDER ========================

    const handleClose = () => {
        if (onClose) {
            onClose();
        } else if (onFinish) {
            onFinish();
        }
    };

    return (
        <>
            <ModalAddObsPedido
                showModalAddObsPedido={showModalAddObsPedido}
                setShowModalAddObsPedido={setShowModalAddObsPedido}
                itensCarrinho={itensCarrinho}
                setItensCarrinho={setItensCarrinho}
                valueDescricao={valueDescricao}
                setValueDescricao={setValueDescricao}
            />
            <ModalAddObsItem
                showModalAddObsItem={showModalAddObsItem}
                setShowModalAddObsItem={setShowModalAddObsItem}
                obsItem={obsItem}
                setObsItem={setObsItem}
                handleSaveObsItem={handleSaveObsItem}
            />

            <ComponentWrapper>
                {/* Botão de Fechar/Recolher com seta >> */}
                <CollapseButton onClick={handleClose} title={t('common:buttons.close')}>
                    <HiChevronDoubleRight />
                </CollapseButton>

                {loading && (
                    <LoadingWrapper>
                        <Loading type={"spinningBubbles"} color="#318CD5" />
                    </LoadingWrapper>
                )}

                <ModernLayout>
                {/* ===== Menu Section (Left) ===== */}
                <MenuSection>
                    <MenuHeader>
                        <HeaderTitle>
                            <h2>
                                <MdFastfood style={{ color: '#318CD5' }} />
                                {t('newOrder.title', { name: mesaName })}
                            </h2>
                        </HeaderTitle>
                        <SendToCartBtn onClick={handleEnviarParaCarrinho}>
                            <MdShoppingCartCheckout />
                            {t('newOrder.sendToCart')}
                        </SendToCartBtn>
                    </MenuHeader>

                    <MenuContent>
                        <CategoriesSidebar>
                            <h3>{t('newOrder.categories')}</h3>
                            <CategoriesList>
                                {categoriasSorted
                                    .filter(cats => itensSorted.some(item => item.category_item_id === cats._id))
                                    .map(c => (
                                        <CategoryBtn
                                            key={c._id}
                                            active={c._id === selectedCategoria}
                                            onClick={() => handleScrollOnClick(c._id)}
                                        >
                                            {c.title}
                                        </CategoryBtn>
                                    ))}
                            </CategoriesList>
                        </CategoriesSidebar>

                        <ItemsContainer>
                            {categoriasSorted
                                .filter(category => itensSorted.some(item => item.category_item_id === category._id))
                                .map(category => (
                                    <CategorySectionStyled key={category._id}>
                                        <CategoryHeader id={category._id}>
                                            <h4>{category.title}</h4>
                                        </CategoryHeader>
                                        <ItemsGrid>
                                            {itensSorted
                                                .filter(item => item.category_item_id === category._id)
                                                .filter(item => !item.out_salao)
                                                .map(produtos => {
                                                    const itemSelecionado = itensSelecionados.find(i => i._id === produtos._id);
                                                    return (
                                                        <ItemCard
                                                            key={produtos._id}
                                                            selected={!!itemSelecionado}
                                                            onClick={() => handleItemClick(produtos)}
                                                        >
                                                            <ItemImage>
                                                                <SafeImage
                                                                    loading="lazy"
                                                                    src={produtos.image}
                                                                    alt={produtos.title}
                                                                    fallback={<MdFastfood />}
                                                                />
                                                            </ItemImage>
                                                            <ItemInfo>
                                                                <h5>{produtos.title}</h5>
                                                                <div className="price">
                                                                    {formatPriceWithSymbol(produtos.price_salao || produtos.price)}
                                                                </div>
                                                                {itemSelecionado && (
                                                                    <ItemQuantity>
                                                                        <button onClick={(e) => { e.stopPropagation(); decrementCount(produtos); }}>-</button>
                                                                        <input
                                                                            type='number'
                                                                            onChange={(e) => handleChange(e, produtos)}
                                                                            value={itemSelecionado.quantity || 0}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        />
                                                                        <button onClick={(e) => { e.stopPropagation(); incrementCount(produtos); }}>+</button>
                                                                    </ItemQuantity>
                                                                )}
                                                            </ItemInfo>
                                                        </ItemCard>
                                                    );
                                                })}
                                        </ItemsGrid>
                                    </CategorySectionStyled>
                                ))}
                        </ItemsContainer>
                    </MenuContent>
                </MenuSection>

                {/* ===== Cart Section (Right) ===== */}
                <CartSection>
                    <CartHeader>
                        <CartTitle>
                            <h3>{t('newOrder.cartTitle')}</h3>
                        </CartTitle>
                        <CartActions>
                            <ActionBtn onClick={() => handleAddObsPedido()}>
                                {t('newOrder.observation')}
                            </ActionBtn>
                            {editarPedido ?
                                <ActionBtn variant="primary" active onClick={handleConcluirEdicao}>
                                    {t('newOrder.exit')}
                                </ActionBtn>
                                :
                                <ActionBtn onClick={handleEditaPedido}>{t('newOrder.edit')}</ActionBtn>
                            }
                            <ActionBtn variant="danger" onClick={handleDeletePedido}>{t('newOrder.delete')}</ActionBtn>
                        </CartActions>
                    </CartHeader>

                    <CartItems>
                        {itensCarrinho?.length === 0 ? (
                            <EmptyCart>
                                <MdShoppingCartCheckout />
                                <h4>{t('newOrder.emptyCart')}</h4>
                                <p>{t('newOrder.emptyCartMessage')}</p>
                            </EmptyCart>
                        ) : (
                            <div style={{ padding: '12px' }}>
                                {Array.isArray(itensCarrinho) && itensCarrinho.map((produtos, i) => (
                                    <div key={i} style={{ marginBottom: '10px', padding: '12px', background: '#f8fafc', borderRadius: '10px', border: '1px solid #e5e7eb' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b', marginBottom: '4px' }}>{produtos.title}</div>
                                                <div style={{ fontSize: '13px', fontWeight: '700', color: '#318CD5' }}>
                                                    {formatPriceWithSymbol(produtos.quantity * (produtos.price_salao || produtos.price))}
                                                </div>
                                            </div>
                                            {editarPedido ? (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '0', background: 'white', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                    <button style={{ width: '28px', height: '28px', border: 'none', background: 'transparent', cursor: 'pointer' }} onClick={() => decrementCountLocalStorage(i)}>-</button>
                                                    <input style={{ width: '36px', height: '28px', border: 'none', borderLeft: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', textAlign: 'center', fontSize: '13px', fontWeight: '600' }} type='number' onChange={(e) => handleChangeLocalStorage(e, i)} value={produtos.quantity || 0} />
                                                    <button style={{ width: '28px', height: '28px', border: 'none', background: 'transparent', cursor: 'pointer' }} onClick={() => incrementCountLocalStorage(i)}>+</button>
                                                </div>
                                            ) : (
                                                <div style={{ background: '#318CD5', color: 'white', padding: '4px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600' }}>{produtos.quantity}x</div>
                                            )}
                                        </div>
                                        {renderAdicionais(i, produtos.adicionais)}
                                        {produtos.obs_item && (
                                            <div style={{ background: 'rgba(245, 158, 11, 0.1)', border: '1px solid rgba(245, 158, 11, 0.2)', borderRadius: '6px', padding: '8px', marginTop: '8px', fontSize: '11px' }}>
                                                <span style={{ fontWeight: '600', color: '#f59e0b' }}>{t('newOrder.itemObservation')}</span> {produtos.obs_item}
                                            </div>
                                        )}
                                        <div style={{ display: 'flex', gap: '8px', marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #e5e7eb' }}>
                                            <button style={{ flex: 1, padding: '6px', border: '1px solid #3b82f6', borderRadius: '6px', background: 'white', color: '#3b82f6', fontSize: '10px', fontWeight: '600', cursor: 'pointer', textTransform: 'uppercase' }} onClick={() => handleAddObsItem(produtos, i)}>{t('newOrder.addObservation')}</button>
                                            <button style={{ flex: 1, padding: '6px', border: '1px solid #ef4444', borderRadius: '6px', background: 'white', color: '#ef4444', fontSize: '10px', fontWeight: '600', cursor: 'pointer', textTransform: 'uppercase' }} onClick={() => handleRemoveItem(produtos, i)}>{t('newOrder.deleteItem')}</button>
                                        </div>
                                    </div>
                                ))}
                                {valueDescricao !== '' && (
                                    <div style={{ background: 'rgba(59, 130, 246, 0.1)', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '8px', padding: '10px', marginTop: '10px' }}>
                                        <span style={{ fontSize: '11px', fontWeight: '600', color: '#3b82f6' }}>{t('newOrder.orderObservation')}</span>
                                        <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#374151' }}>{valueDescricao}</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </CartItems>

                    <CartFooter>
                        <CartSummary>
                            <SummaryRow>
                                <span>{t('newOrder.subtotal')}</span>
                                <strong>{formatPriceWithSymbol(subTotal)}</strong>
                            </SummaryRow>
                            <SummaryRow>
                                <span>{t('newOrder.discount')}</span>
                                <strong>{formatPriceWithSymbol(0)}</strong>
                            </SummaryRow>
                            <SummaryRow className="total">
                                <span>{t('newOrder.total')}</span>
                                <strong>{formatPriceWithSymbol(valorTotal)}</strong>
                            </SummaryRow>
                        </CartSummary>

                        <CustomerSection ref={containerRef}>
                            <div style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', marginBottom: '10px' }}>{t('newOrder.customerTitle')}</div>
                            {localMesaClientes.length > 0 && (
                                <MesaClientesList>
                                    {localMesaClientes
                                        .filter(c => c.nome && c.nome !== 'Nao informado' && c.nome !== 'Não informado')
                                        .map((cliente, idx) => (
                                        <MesaClienteChip
                                            key={idx}
                                            active={selectedMesaCliente?.nome === cliente.nome}
                                            onClick={() => handleSelectMesaCliente(cliente)}
                                        >
                                            <MdPerson />
                                            {cliente.nome}
                                        </MesaClienteChip>
                                    ))}
                                    <MesaClienteAddBtn onClick={() => { setSelectedMesaCliente(null); setNomeCliente(''); setTelefone(''); }}>
                                        <MdPersonAdd />
                                        Novo
                                    </MesaClienteAddBtn>
                                </MesaClientesList>
                            )}
                            <CustomerInputs>
                                <PhoneInput
                                    name="celular"
                                    onChange={handleTelefoneChange}
                                    value={telefone}
                                    placeholder={t('newOrder.phonePlaceholder')}
                                    autoComplete="off"
                                />
                                <input
                                    type="text"
                                    value={nomeCliente}
                                    onChange={handleNomeChange}
                                    placeholder={t('newOrder.clientNamePlaceholder')}
                                    autoComplete="off"
                                />
                            </CustomerInputs>
                            {clientes.length > 0 && (
                                <CustomersDropdown>
                                    {clientes.map(cliente => (
                                        <CustomerOption
                                            key={cliente._id}
                                            onClick={() => handleClienteClick(cliente)}
                                        >
                                            <span className="customer-phone">{formatPhoneDisplay(cliente.telefone_completo || cliente.telefone)}</span>
                                            <span className="customer-name">{cliente.nome}</span>
                                        </CustomerOption>
                                    ))}
                                </CustomersDropdown>
                            )}
                        </CustomerSection>

                        <SubmitBtn onClick={handleSubmitAPI} type="button">
                            {t('newOrder.submitOrder')}
                        </SubmitBtn>
                    </CartFooter>
                </CartSection>
                </ModernLayout>
            </ComponentWrapper>

            {selectedItem && (
                <ModalAdicionais
                    show={showAdicionaisModal}
                    onClose={() => setShowAdicionaisModal(false)}
                    item={selectedItem}
                    idEmpresa={idEmpresa}
                    nomeEmpresaForUrl={nomeEmpresaForUrl}
                    quantidades={quantidades}
                    setQuantidades={setQuantidades}
                    adicionaisCompletos={adicionaisCompletos}
                    setAdicionaisCompletos={setAdicionaisCompletos}
                    handleFinalizarAdicionais={handleFinalizarAdicionais}
                />
            )}
        </>
    );
}

export default PedidosComponent;
